module.exports = __webpack_public_path__ + "img/lnzt2x.6ae9746b.png";